import type { RouteRecordRaw } from 'vue-router';

export const inboxRoute: RouteRecordRaw = {
  path: '/inbox',
  name: 'Inbox',
  component: () => import('./pages/InboxPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:notifications:list'),
  },
};
